import { ItemOrcamentoController } from "app/controllers/orcamento/itemOrcamentoController"
import { useAppSelector } from "app/redux/hooks"
import { ControllerLegado } from "app/types/ControllerLegado"
import { IItemOrcamento } from "app/types/IItemOrcamento"
import { WindowMU } from "app/types/WindowMU"
import React, { useEffect, useState } from "react"
import { ItensOrcamentoContainer } from "../itens-orcamento/ItensOrcamentoContainer"
import { renderizarComponentReact } from "../renderizarOuRemoverComponentReact"
import { EditarItemContainer } from "./EditarItemContainer"
import { DadosProdutoSemEstoqueDisponivel } from "./produto-sem-estoque-disponivel/ProdutoSemEstoqueDisponivel"
import { ProdutoSemEstoqueDisponivelContainer } from "./produto-sem-estoque-disponivel/ProdutoSemEstoqueDisponivelContainer"
import { RegistrarPerdaCotacaoContainer } from "./registrar-perda-cotacao/RegistrarPerdaCotacaoContainer"
declare var window: WindowMU

export type TelaEdicaoItensContainerProps = {
    itemOrcamentoController:ControllerLegado
    identificadoresItensSelecionados: number[]
    indexItemAtual?:number
}

type ItemParaEdicao = {
    identificadorItem: number
    index: number
}

export const TelaEdicaoItensContainer = (props: TelaEdicaoItensContainerProps) => {
    const orcamento = useAppSelector(store => store.orcamento)
    const [componenteParaExibir, setComponenteParaExibir] = useState<"EDICAO_ITEM" | "PRODUTO_SEM_ESTOQUE_DISPONIVEL" | "REGISTRAR_PERDA_COTACAO">("EDICAO_ITEM")
    const [itemAtual, setItemAtual] = useState<ItemParaEdicao>({
        identificadorItem: props.identificadoresItensSelecionados[0],
        index: 0
    })
    
    const [dadosPerdaCotacao, setDadosPerdaCotacao] = useState<{
        manterItem: boolean
        dadosProdutoSemEstoqueDisponivel: DadosProdutoSemEstoqueDisponivel
        quantidadeProduto: number
    }>({
        manterItem: false,
        dadosProdutoSemEstoqueDisponivel: null,
        quantidadeProduto: null
    })

    useEffect(() => {
        let campoQuantidade = document.getElementById("EditarItem_Quantidade");
        if (campoQuantidade) {
            campoQuantidade.focus();
        }
    }, [itemAtual])


    return <>
        {componenteParaExibir == "EDICAO_ITEM" && itemAtual != null && 
            <EditarItemContainer
                itemOrcamentoController={props.itemOrcamentoController}
                onExibirTelaProdutoSemEstoqueDisponivel={() => setComponenteParaExibir("PRODUTO_SEM_ESTOQUE_DISPONIVEL")}
                botaoAnteriorDesativado={itemAtual.index == 0}
                exibirBotoesProximoEAnterior={props.identificadoresItensSelecionados.length > 1}
                identificadorItem={itemAtual.identificadorItem}
                onBotaoAnteriorClicado={() => setItemAtual({
                    identificadorItem: props.identificadoresItensSelecionados[itemAtual.index - 1],
                    index: itemAtual.index - 1
                })}
                onBotaoProximoClicado={() => {
                    const ultimoItem = () => itemAtual.index == props.identificadoresItensSelecionados.length - 1

                    if (ultimoItem()) {
                        renderizarComponentReact(<ItensOrcamentoContainer/>, "conteudo-pagina", true)
                        // window.orcamentoController.showView({
                        //     region: {
                        //       name: "itemOrcamentoRegion",
                        //         selector: "#itens-orcamento-region"
                        //     },
                        //     controller: {
                        //       type: ItemOrcamentoController,
                        //         args: {
                        //             model: window.orcamentoController.model,
                        //             orcamentoController: window.orcamentoController,
                        //             readOnly: orcamento.SomenteLeitura || orcamento.CodigoDAV !== "" 
                        //         }
                        //     }
                        //   })
                    } else {
                        setItemAtual({
                            identificadorItem: props.identificadoresItensSelecionados[itemAtual.index + 1],
                            index: itemAtual.index + 1
                        })
                    }
                }}
                />}

        {componenteParaExibir == "PRODUTO_SEM_ESTOQUE_DISPONIVEL" && 
            <ProdutoSemEstoqueDisponivelContainer
                identificadorItemSelecionado={itemAtual.identificadorItem}
                itemOrcamentoController={props.itemOrcamentoController}
                onVoltar={() => setComponenteParaExibir("EDICAO_ITEM")}
                onRegistrarPerdaCotacao={dados => {
                    setDadosPerdaCotacao(dados)
                    setComponenteParaExibir("REGISTRAR_PERDA_COTACAO")
                }}
                onVoltarParaEdicaoItens={() => setComponenteParaExibir("EDICAO_ITEM")}/>}

        {componenteParaExibir == "REGISTRAR_PERDA_COTACAO" &&
            <RegistrarPerdaCotacaoContainer 
                identificadorItemSelecionado={itemAtual.identificadorItem}
                manterItem={dadosPerdaCotacao.manterItem} 
                dadosCotacaoQuantidadePerdida={dadosPerdaCotacao.dadosProdutoSemEstoqueDisponivel} 
                perdaTotal={false} // 470698
                editarIndexItens={0} 
                quantidadeProduto={dadosPerdaCotacao.quantidadeProduto}
                itemOrcamentoController={props.itemOrcamentoController}
                onVoltar={() => setComponenteParaExibir("PRODUTO_SEM_ESTOQUE_DISPONIVEL")}
                onVoltarParaEdicaoItens={() => setComponenteParaExibir("EDICAO_ITEM")}
            />} 
    </>
}